import React, { useContext } from "react";
import { Switch, Route } from "react-router-dom";

// styles
import "./MainContent.css";

// pages
import Login from "../../pages/authentication/Login/Login.page";
import Logout from "../../pages/authentication/Logout/Logout.page";

import Schedule from "../../pages/jobdays/Schedule/Schedule.page";
import JobDayDetails from "../../pages/jobdays/JobDayDetail/JobDayDetail.page";
import SplitJobDay from "../../pages/jobdays/SplitJobDay/SplitJobDay.page";
import ProcessTimeTickets from "../../pages/jobdays/ProcessTimeTickets/ProcessTimeTickets.page";
import ReplaceCrewMember from "../../pages/jobdays/ReplaceCrewMember/ReplaceCrewMember.page";
import SendReceipt from "../../pages/jobdays/SendReceipt/SendReceipt.page";

import MyJobs from "../../pages/job/MyJobs/MyJobs.page";
import JobDetails from "../../pages/job/JobDetail/JobDetails.page";

import MyRequests from "../../pages/requests/MyRequests/MyRequests.page";
import RequestDetails from "../../pages/requests/RequestDetails/RequestDetails.page";
import NewEquipmentRequest from "../../pages/requests/NewEquipmentRequest/NewEquipmentRequest.page";

// contexts
import { AuthenticationContext } from "../../contexts/authentication";
import { Typography } from "@mui/material";

const MainContent = () => {
  const authentication = useContext(AuthenticationContext);
  // routes
  let routes = null;

  if (authentication.isLoggedIn) {
    routes = (
      <React.Fragment>
        <Route exact path="/jobs" component={MyJobs} />
        <Route exact path="/jobs/details/:jobId" component={JobDetails} />

        <Route exact path="/requests" component={MyRequests} />
        <Route exact path="/requests/new" component={NewEquipmentRequest} />
        <Route
          exact
          path="/requests/new/:jobId"
          component={NewEquipmentRequest}
        />
        <Route
          exact
          path="/requests/details/:requestId"
          component={RequestDetails}
        />

        <Route exact path="/schedule" component={Schedule} />
        <Route
          exact
          path="/schedule/details/:jobDayId"
          component={JobDayDetails}
        />
        <Route exact path="/schedule/split/:jobDayId" component={SplitJobDay} />
        <Route
          exact
          path="/schedule/time-tickets/:jobDayId"
          component={ProcessTimeTickets}
        />
        <Route
          exact
          path="/schedule/send-receipt/:jobDayId"
          component={SendReceipt}
        />
        <Route
          exact
          path="/schedule/replace-crew-member/:jobDayId"
          component={ReplaceCrewMember}
        />

        <Route exact path="/logout" component={Logout} />
        <Route
          exact
          path="/"
          component={() => (
            <Typography variant="h2">Welcome to the site!</Typography>
          )}
        />
      </React.Fragment>
    );
  } else {
    routes = (
      <React.Fragment>
        <Route path="/" render={(props) => <Login {...props} />} />
      </React.Fragment>
    );
  }

  return (
    <div className="main-content">
      <Switch>{routes}</Switch>
    </div>
  );
};

export default MainContent;
